import { useState } from 'react'
import AmendAndResendCertificateModal from './AmendAndResendCertificate'
import ChangeKitSkuModal from './ChangeKitSkuModal'
import DeactivateKitModal from './DeactivateKitModal'
import MarkKitObservedModal from './MarkKitObservedModal'
import ReactivateKitModal from './ReactivateKitModal'
import UncompleteKitModal from './UncompleteKit'

const AmendAndResendCertificate = ({ kitId }: { kitId: string }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <div className="message is-info mt-3">
        <div className="message-header">
          <p>Amend & Re-send Certificate</p>
        </div>
        <div className="message-body">
          <p>Amend certificate details & resend certificate.</p>
          <div className="buttons is-right mt-3">
            <button className="button is-info is-outlined" onClick={() => setShowModal(true)}>
              Amend and re-send certificate
            </button>
          </div>
        </div>
      </div>
      {showModal && <AmendAndResendCertificateModal kitId={kitId} onRequestClose={() => setShowModal(false)} />}
    </>
  )
}

const UncompleteKit = ({ kitId }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <div className="message is-info mt-3">
        <div className="message-header">
          <p>Uncomplete Kit</p>
        </div>
        <div className="message-body">
          <p>
            Set this COMPLETED kit back to REGISTERED so that it can be re-registered. Use if a test was mistakenly
            approved.
          </p>

          <div className="buttons is-right mt-3">
            <button className="button is-info is-outlined" onClick={() => setShowModal(true)}>
              Uncomplete kit
            </button>
          </div>
        </div>
      </div>

      {showModal && <UncompleteKitModal kitId={kitId} onRequestClose={() => setShowModal(false)} />}
    </>
  )
}

const ChangeKitSku = ({ kitId, initialSku }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <div className="message is-info mt-3">
        <div className="message-header">
          <p>Change SKU</p>
        </div>
        <div className="message-body">
          <p>Change the SKU of this kit. Use this if someone mixed up e.g. an inbound and outbound PCR test.</p>

          <div className="buttons is-right mt-3">
            <button className="button is-info is-outlined" onClick={() => setShowModal(true)}>
              Change Kit SKU
            </button>
          </div>
        </div>
      </div>

      {showModal && (
        <ChangeKitSkuModal kitId={kitId} initialSku={initialSku} onRequestClose={() => setShowModal(false)} />
      )}
    </>
  )
}

const ReactivateKit = ({ kitId }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <div className="message is-info mt-3">
        <div className="message-header">
          <p>Reactivate Kit</p>
        </div>
        <div className="message-body">
          <p>
            Set this INACTIVE kit back to CREATED. Use this to reinstate a kit that was previously deactivated (usually
            due to refunding an order that has already shipped).
          </p>

          <div className="buttons is-right mt-3">
            <button className="button is-info is-outlined" onClick={() => setShowModal(true)}>
              Reactivate kit
            </button>
          </div>
        </div>
      </div>

      {showModal && <ReactivateKitModal kitId={kitId} onRequestClose={() => setShowModal(false)} />}
    </>
  )
}

const DeactivateKit = ({ kitId }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <div className="message is-info mt-3">
        <div className="message-header">
          <p>Deactivate Kit</p>
        </div>
        <div className="message-body">
          <p>
            Set this kit to INACTIVE. Use this to cancel a kit so it can't be used - usually because we've refunded an
            order after it already shipped.
          </p>

          <div className="buttons is-right mt-3">
            <button className="button is-info is-outlined" onClick={() => setShowModal(true)}>
              Deactivate kit
            </button>
          </div>
        </div>
      </div>

      {showModal && <DeactivateKitModal kitId={kitId} onRequestClose={() => setShowModal(false)} />}
    </>
  )
}

const MarkKitObserved = ({ kitId }) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <div className="message is-info mt-3">
        <div className="message-header">
          <p>Mark Kit Observed via video</p>
        </div>
        <div className="message-body">
          <p>Mark this kit as 'Observed' meaning someone has supervised the test via video call</p>

          <div className="buttons is-right mt-3">
            <button className="button is-info is-outlined" onClick={() => setShowModal(true)}>
              Mark as observed
            </button>
          </div>
        </div>
      </div>

      {showModal && <MarkKitObservedModal kitId={kitId} onRequestClose={() => setShowModal(false)} />}
    </>
  )
}

const KitActions = ({ kit }) => {
  return (
    <div>
      {kit.status === 'COMPLETED' && (
        <>
          <AmendAndResendCertificate kitId={kit.id} />

          <UncompleteKit kitId={kit.id} />
        </>
      )}

      {kit.status !== 'COMPLETED' && (
        <>
          <ChangeKitSku kitId={kit.id} initialSku={kit.sku} />
        </>
      )}

      <MarkKitObserved kitId={kit.id} />

      {kit.status === 'INACTIVE' && <ReactivateKit kitId={kit.id} />}

      {!['INACTIVE', 'COMPLETED'].includes(kit.status) && <DeactivateKit kitId={kit.id} />}
    </div>
  )
}

export default KitActions
